import React, { useState } from "react";
import moment from "moment";
import Alert from "../../../controls/Alert";

const CountryPermitRequirementsValidator = (props) => {
  const record = props.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) { 
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }   

  if (!error && isNaN(parseInt(record.permitValidityHours))) {
    error = true;
    errorMessage = "'Permit Validity Hours' does not contain a valid number";
  }
  if (!error && (parseInt(record.permitValidityHours) < 0 || parseInt(record.permitValidityHours) > 999)) {
    error = true;
    errorMessage = "'Permit Validity Hours' is outside the allowed value range";
  }
  if (!error && isNaN(parseInt(record.permitPreDepartureValidityHours))) {
    error = true;
    errorMessage = "'Permit Pre Departure Validity Hours' does not contain a valid number";
  }
  if (!error && (parseInt(record.permitPreDepartureValidityHours) < 0 || parseInt(record.permitPreDepartureValidityHours) > 999)) {
    error = true;
    errorMessage = "'Permit Pre Departure Validity Hours' is outside the allowed value range";
  }
  if (!error && isNaN(parseInt(record.permitRequestLeadTimeHours))) {
    error = true;
    errorMessage = "'Permit Request Lead Time Hours' does not contain a valid number";
  }
  if (!error && (parseInt(record.permitRequestLeadTimeHours) < 0 || parseInt(record.permitRequestLeadTimeHours) > 99)) {
    error = true;
    errorMessage = "'Permit Request Lead Time Hours' is outside the allowed value range";
  }
  if (!error && !record.permitRouteType) {
    error = true;
    errorMessage = "'Permit Route Type' is required";
  }
  if (!error && isNaN(parseFloat(record.permitCostAgent))) {
    error = true;
    errorMessage = "'Permit Cost Agent' does not contain a valid number";
  }
  if (!error && (parseFloat(record.permitCostAgent) < 0 || parseFloat(record.permitCostAgent) > 999999.99)) {
    error = true;
    errorMessage = "'Permit Cost Agent' is outside the allowed value range";
  }
  if (!error && isNaN(parseFloat(record.permitCostAuthority))) {
    error = true;
    errorMessage = "'Permit Cost Authority' does not contain a valid number";
  }
  if (!error && (parseFloat(record.permitCostAuthority) < 0 || parseFloat(record.permitCostAuthority) > 999999.99)) {
    error = true;
    errorMessage = "'Permit Cost Authority' is outside the allowed value range";
  }
  if (!error && !record.navigationFeesVia) {
    error = true;
    errorMessage = "'Navigation Fees Via' is required";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default CountryPermitRequirementsValidator;
